export const DEFAULT_TIMEOUT = 300000; // 5 minutes
// export const DEFAULT_TIMEOUT = 30000; // 30 seconds

export const MICRO_SERVICE_ROUTES = {
	NOTIFICATIONS: "/notifications",
	USERS: "/users",
	INSTITUTES: "/institutes",
	CERTIFICATES: "/certificates",
	MEMBERS: "/members",
};
export const API_ROUTES = {
	AUTH: `${MICRO_SERVICE_ROUTES.USERS}/auth/v1`,
	EQUIPMENTS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/equipment`,
	LABS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/labs`,
	USERS: `${MICRO_SERVICE_ROUTES.USERS}/users/v1`,
	NOTIFICATIONS: `${MICRO_SERVICE_ROUTES.NOTIFICATIONS}/notifications`,
	CERTIFICATES: `${MICRO_SERVICE_ROUTES.CERTIFICATES}/certificates`,
	MEMBERS: `${MICRO_SERVICE_ROUTES.MEMBERS}/members`,
} as const;

export const API_PATHS = {
	AUTH: {
		SIGN_IN: "/login",
		SIGN_UP: "/email/register",
		VERIFY_EMAIL: "/verify-email",
		FORGOT_PASSWORD: "/forgot-password",
		RESET_PASSWORD: "/reset-password",
		CHANGE_PASSWORD: "/change-password",
		VERIFY_OTP: "/verify-otp",
		RESEND_OTP: "/resend-otp",
		SET_PASSWORD: "/set-password",
	},
	USER: {
		GET_PROFILE: "/profile",
		PROFILE_IMAGE_UPLOAD_URL: "/profile/image/upload-url",
		PROFILE_IMAGE_UPDATE: "/profile/image",
		COMMITTE_MEMBERS: "/committee-members",
		COMMITTE_MEMBERS_BULK: "/committee-members/bulk",
		COMMITTEE_MEMBER_DETAILS: (uuid: string) => `/committee-members/${uuid}`,
		ACTIVATE_MEMBER: (uuid: string) => `/${uuid}/activate`,
		DEACTIVATE_MEMBER: (uuid: string) => `/${uuid}/deactivate`,
	},

	INSTITIUTE: {
		TECHNOLOGY: "/technology",
		MEMBER_TYPES: "/memberType",
		DESIGNATION: "/designation",
		QUALIFICATION: "/qualification",
		TECH_QUALIFICATION: "/tech-qualification",
		PROVINCE: "/province",
		GET_DIVISION_BY_PROVINCE: "/division/province",
		GET_DISTRICTS_BY_DIVISION: "/district/division",
		GET_TEHSILS_BY_DISTRICT: "/tehsil/district",
		GET_CITIES_BY_DISTRICT: "/city/district",
		GET_ALL_UC: "/union-council",
		COURSE_STREAM: "/course-stream",
		COURSES: "/course",
		SECTOR: "/sector",
		APPLICATIONS_PENDING: "/applications/admin/pending",
		APPLICATIONS_SCRUTINIZED: "/applications/admin/scrutinized",
		APPLICATIONS_INSPECTED: "/applications/admin/rejected",
		APPLICATIONS: "/applications",
		COMMITTEE_APPLICATION: "/application-committee/inspection",
		APPLICATIONS_APPROVED: "/applications/admin/approved",
		FILE_UPLOAD_URL: "/attachments/upload",
	},

	NOTIFICATIONS: {
		READ: "/read",
		STREAM: "/user/{id}/stream",
	},
	CERTIFICATES: {
		GET_DETAILS: "/details",
		DOWNLOAD: "/download",
	},
	ATTACHMENTS: {
		GET_IMAGE: "attachments"
	}
};

const ACTIONS = {
	REJECT: "reject",
};

export const SERVER_ROUTES = {
	AUTH: {
		SIGN_IN: API_ROUTES?.AUTH + API_PATHS?.AUTH?.SIGN_IN,
		SIGN_UP: API_ROUTES?.AUTH + API_PATHS?.AUTH?.SIGN_UP,
		VERIFY_EMAIL: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_EMAIL,
		FORGOT_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.FORGOT_PASSWORD,
		RESET_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.RESET_PASSWORD,
		CHANGE_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.CHANGE_PASSWORD,
		VERIFY_OTP: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_OTP,
		RESEND_OTP: API_ROUTES.AUTH + API_PATHS.AUTH.RESEND_OTP,
		SET_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.SET_PASSWORD,
	},
	USER: {
		GET_PROFILE: API_ROUTES.AUTH + API_PATHS.USER.GET_PROFILE,
		PROFILE_IMAGE_UPLOAD_URL: API_ROUTES.USERS + API_PATHS.USER.PROFILE_IMAGE_UPLOAD_URL,
		PROFILE_IMAGE_UPDATE: API_ROUTES.USERS + API_PATHS.USER.PROFILE_IMAGE_UPDATE,
		PROFILE_UPDATE: API_ROUTES.USERS + API_PATHS.USER.GET_PROFILE,
		COMMITTE_MEMBERS: API_ROUTES.USERS + API_PATHS.USER.COMMITTE_MEMBERS,
		COMMITTE_MEMBERS_BULK: API_ROUTES.USERS + API_PATHS.USER.COMMITTE_MEMBERS_BULK,
		COMMITTEE_MEMBER_DETAILS: (uuid: string) => API_ROUTES.USERS + API_PATHS.USER.COMMITTEE_MEMBER_DETAILS(uuid),
		ACTIVATE_MEMBER: (uuid: string) => API_ROUTES.USERS + API_PATHS.USER.ACTIVATE_MEMBER(uuid),
		DEACTIVATE_MEMBER: (uuid: string) => API_ROUTES.USERS + API_PATHS.USER.DEACTIVATE_MEMBER(uuid),
	},

	NOTIFICATIONS: {
		NOTIFICATIONS: API_ROUTES.NOTIFICATIONS,
		READ: (id: string) => `${API_ROUTES.NOTIFICATIONS}/${id}${API_PATHS.NOTIFICATIONS.READ}`,
		STREAM: (id: string) => `${API_ROUTES.NOTIFICATIONS}${API_PATHS.NOTIFICATIONS.STREAM.replace("{id}", id)}`,
	},
	EQUIPMENTS: {
		GET: (limit: number, page: number) => `${API_ROUTES.EQUIPMENTS}?limit=${limit}&page=${page}`,
		CREATE: API_ROUTES.EQUIPMENTS,
		UPDATE: (id: string) => `${API_ROUTES.EQUIPMENTS}/${id}`,
		DELETE: (id: string) => `${API_ROUTES.EQUIPMENTS}/${id}`,
	},
	LABS: {
		GET: (limit: number, page: number) => `${API_ROUTES.LABS}?limit=${limit}&page=${page}`,
		CREATE: API_ROUTES.LABS,
		UPDATE: (uuid: string) => `${API_ROUTES.LABS}/${uuid}`,
		DELETE: (uuid: string) => `${API_ROUTES.LABS}/${uuid}`,
	},
	INSTITUTE: {
		COMMITTEE_APPLICATION: (status: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/${API_PATHS.INSTITIUTE.COMMITTEE_APPLICATION}/${status}`,
		// Dynamic inspection endpoint: /institutes/application-committee/inspection/{status}
		GET_INSPECTION_APPLICATIONS: (status: string, limit: number, page: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/inspection/${status}?limit=${limit}&page=${page}`,
		// Inspection stats endpoint: /institutes/application-committee/inspection/stats
		GET_INSPECTION_STATS: `${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/inspection/stats`,
		APPLICATIONS_REJECTED: (applicationId: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS}/${applicationId}/${ACTIONS.REJECT}`,
		GET_INSTITUTES: MICRO_SERVICE_ROUTES.INSTITUTES + "/institutes",
		GET_INSPECTION_APPLICATIONS_BY_ID: (applicationId: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS}/${applicationId}`,
		GET_APPLICATION_DETAILS: (applicationId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}`,

		// NEW split apis for the scrutiny/inspection start here
		GET_BASIC_DETAILS: (applicationId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/basic-detail`,
		GET_BUILDING_DETAILS: (applicationId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/building-detail`,

		GET_ATTACHMENT_DETAILS: (applicationId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/application-attachment`,

		GET_COURSES_DETAILS: (applicationId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/application-courses`,

		GET_COURSES_FACULTIES_DETAILS: (applicationId: string, courseId?: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/application-courses/${courseId}/faculties`,

		GET_COURSES_LAB_EQUIPMENT_DETAILS: (applicationId: string, courseId?: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/application-courses/${courseId}/lab-equipments`,

		GET_APPLICATION_COURSE_LABS: (catalogCourseUuid: string, page: number, limit: number, search?: string) => {
			const base = `${MICRO_SERVICE_ROUTES.INSTITUTES}/labs/courses/${catalogCourseUuid}/labs?page=${page}&limit=${limit}`;
			return search?.trim() ? `${base}&search=${encodeURIComponent(search.trim())}` : base;
		},
		GET_COMMITTEE_MEMBER_ASSIGNED_LABS: (
			applicationCourseUuid: string,
			committeeMemberUuid: string,
			page?: number,
			limit?: number,
		) => {
			const base = `${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/application-courses/${applicationCourseUuid}/committee-members/${committeeMemberUuid}/labs`;
			if (page !== undefined && limit !== undefined) {
				return `${base}?page=${page}&limit=${limit}`;
			}
			return base;
		},
		GET_COMMITTEE_MEMBER_LAB_EQUIPMENTS: (
			applicationCourseUuid: string,
			committeeMemberUuid: string,
			labUuid: string,
			page: number,
			limit: number,
			search?: string,
		) => {
			const base = `${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/application-courses/${applicationCourseUuid}/committee-members/${committeeMemberUuid}/labs/${labUuid}/equipments?page=${page}&limit=${limit}`;
			return search?.trim() ? `${base}&search=${encodeURIComponent(search.trim())}` : base;
		},

		// ENDS here

		SUBMIT_APPLICATION_SCRUTINY: (id: number) => MICRO_SERVICE_ROUTES.INSTITUTES + `/applications/${id}/inspect`,
		SUBMIT_APPLICATION_COMMITTEE: MICRO_SERVICE_ROUTES.INSTITUTES + "/application-committee",
		GET_COMMITTEE_APPROVAL_PENDING: (limit: number, page: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/committee-approval-pending?page=${page}&limit=${limit}`,
		GET_INSTITUTE_DETAILS: (instituteId: string) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/institutes/${instituteId}`,
		GET_INSPECTION_TYPE: MICRO_SERVICE_ROUTES.INSTITUTES + "/inspection-types",
		GET_ALL_TECHNOLOGIES: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.TECHNOLOGY,
		GET_MEMBER_TYPES: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.MEMBER_TYPES,
		GET_ALL_DESIGNATIONS: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.DESIGNATION,
		GET_HEIGHST_QUALIFICATION: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.QUALIFICATION,
		GET_TECH_QUALIFICATION: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.TECH_QUALIFICATION,
		GET_ALL_PROVICE: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.PROVINCE,
		GET_ALL_DIVISIONS_BY_PROVINCE: (id: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_DIVISION_BY_PROVINCE}/${id}/divisions`,
		GET_ALL_DISTRICTS_BY_DIVISION: (id: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_DISTRICTS_BY_DIVISION}/${id}/districts`,
		GET_ALL_TEHSILS_BY_DISTRICT: (id: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_TEHSILS_BY_DISTRICT}/${id}/tehsils`,
		GET_ALL_CITIES_BY_DISTRICT: (id: string | number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_CITIES_BY_DISTRICT}/${id}/cities`,
		GET_ALL_UC: `${MICRO_SERVICE_ROUTES.INSTITUTES}` + `${API_PATHS.INSTITIUTE.GET_ALL_UC}`,
		GET_COURSE_STREAM: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSE_STREAM,
		CREATE_COURSE: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.COURSES,
		GET_COURSES: (limit: number, page: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.COURSES}?limit=${limit}&page=${page}`,
		GET_SECTOR: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.SECTOR,
		GET_APPLICATIONS_PENDING: (limit: number, page: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_PENDING}?limit=${limit}&page=${page}`,
		GET_APPLICATIONS_SCRUTINIZED: (limit: number, page: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_SCRUTINIZED}?limit=${limit}&page=${page}`,
		GET_APPLICATIONS_INSPECTED: (limit: number, page: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_INSPECTED}?limit=${limit}&page=${page}`,
		GET_APPLICATIONS_REJECTED: (limit: number, page: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS}?limit=${limit}&page=${page}`,

		GET_APPLICATIONS_APPROVED: (limit: number, page: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}${API_PATHS.INSTITIUTE.APPLICATIONS_APPROVED}?limit=${limit}&page=${page}`,
		GET_COMMITTEE_HISTORY: (limit: number, page: number) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/inspection/completed?limit=${limit}&page=${page}`,
		GET_ASSIGNED_COURSES: (applicationId: string, committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/committees/${committeeId}/labs/assigned`,
		SAVE_INSPECTION: (applicationId: string, committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/committees/${committeeId}/inspect-labs`,
		GET_ALL_LABS_WITH_INSPECTION: (applicationId: string, committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/committees/${committeeId}/labs`,
		CONVENER_APPROVE_EQUIPMENT_BULK: (applicationId: string, committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/committees/${committeeId}/convener-approve-equipment`,
		SUBMIT_INSPECTION: (applicationId: string, committeeId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/applications/${applicationId}/committees/${committeeId}/submit-inspection`,
		GET_ATTACHMENT_URL: (key: string) => `${MICRO_SERVICE_ROUTES.INSTITUTES}/attachments/${key}`,
		DOWNLOAD_ATTACHMENTS_ZIP: (applicationId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/attachments/download-zip?applicationId=${applicationId}`,
		REJECT_APPLICATION: (applicationId: string) =>
			`${MICRO_SERVICE_ROUTES.INSTITUTES}/application-committee/${applicationId}/reject`,
		ATTACHMENT_UPLOAD: MICRO_SERVICE_ROUTES.INSTITUTES + API_PATHS.INSTITIUTE.FILE_UPLOAD_URL,
	},
	CERTIFICATES: {
		GET_DETAILS: (instituteId: string) =>
			`${API_ROUTES.CERTIFICATES}/${instituteId}${API_PATHS.CERTIFICATES.GET_DETAILS}`,
		DOWNLOAD: (certificateId: string) =>
			`${API_ROUTES.CERTIFICATES}/${certificateId}${API_PATHS.CERTIFICATES.DOWNLOAD}`,
	},
	MEMBERS: {
		GET_DETAILS: (memberId: string) => `${API_ROUTES.MEMBERS}/${memberId}/details`,
		TOGGLE_STATUS: (memberId: string) => `${API_ROUTES.MEMBERS}/${memberId}/status`,
	},
	ATTACHEMENT: {
		GLOBAL_GET_ATTACHEMENT: `${MICRO_SERVICE_ROUTES.INSTITUTES}/${API_PATHS.ATTACHMENTS.GET_IMAGE}`
	}
} as const;

export const QUERY_KEYS = {
	USER: {
		PROFILE_IMAGE_UPDATE: "profile-image-update",
		PROFILE_UPDATE: "profile-update",
		GET_PROFILE: "profile",
		COMMITTE_MEMBERS: "committee-members",
		MEMBERS: "members",
	},
	INSTITUTES: {
		INSTITUTES: "institutes",
		INSTITUTE_DETAILS: "institute-details",
		APPLICATION_DETAILS: "application-details",
		APPLICATION_BASIC_DETAILS: "basic-details",
		APPLICATION_BUILDING_DETAILS: "building-details",
		APPLICATION_ATTACHMENT_DETAILS: "attachment-details",
		APPLICATION_COURSES_DETAILS: "courses-details",
		APPLICATION_FACULTIES_DETAILS: "faculties-details",
		APPLICATION_LAB_EQUIPMENT_DETAILS: "lab-equipment-details",
		APPLICATION_COURSE_LABS: "application-course-labs",
		COMMITTEE_MEMBER_ASSIGNED_LABS: "committee-member-assigned-labs",
		LAB_EQUIPMENTS_PAGINATED: "lab-equipments-paginated",
		EQUIPMENTS: "equipment",
		LABS: "labs",
		MEMBER_TYPE: "member-type",
		TECHNOLOGIES: "technologies",
		DESIGNATIONS: "designations",
		QUALIFICATIONS: "qualifications",
		TECH_QUALIFICATIONS: "tech-qualifications",
		PROVINCES: "provinces",
		DIVISIONS: "divisions",
		DISTRICTS: "districts",
		TEHSILS: "tehsils",
		CITIES: "cities",
		UNION_COUNCEL: "unionCouncils",
		COURSE_STREAM: "course-stream",
		COURSES: "courses",
		SECTOR: "sector",
		APPLICATIONS_PENDING: "applications-pending",
		APPLICATIONS_SCRUTINIZED: "applications-scrutinized",
		APPLICATIONS_INSPECTED: "applications-inspected",
		APPLICATIONS_REJECTED: "applications-rejected",
		APPLICATIONS_APPROVED: "applications-approved",
		INSPECTION_APPLICATIONS: "inspection-applications",
		INSPECTION_STATS: "inspection-stats",
		COMMITTEE_APPROVAL_PENDING: "committee-approval-pending",
		INSPECTION_TYPES: "inspection-types",
	},
	CERTIFICATES: {
		DETAILS: "certificate-details",
		DOWNLOAD: "certificate-download",
	},
	MEMBERS: {
		DETAILS: "member-details",
		STATUS: "member-status",
		COMMITTEE_MEMBER_DETAILS: "committee-member-details",
		ACTIVATE_MEMBER: "activate-member",
		DEACTIVATE_MEMBER: "deactivate-member",
	},
	APPLICATIONS: {
		COMMITTEE_HISTORY: "committee-history",
	},
};
export const QUERY_PARAMS = {};

export const AUTH_ENDPOINTS = [
	SERVER_ROUTES.AUTH.SIGN_IN,
	SERVER_ROUTES.AUTH.SIGN_UP,
	SERVER_ROUTES.AUTH.FORGOT_PASSWORD,
	SERVER_ROUTES.AUTH.RESET_PASSWORD,
	SERVER_ROUTES.AUTH.VERIFY_OTP,
	SERVER_ROUTES.AUTH.RESEND_OTP,
	SERVER_ROUTES.AUTH.VERIFY_EMAIL,
	SERVER_ROUTES.AUTH.SET_PASSWORD,
];
